// extracted by mini-css-extract-plugin
module.exports = {"IAndCSecurityAdvisor":"IAndCSecurityAdvisor_IAndCSecurityAdvisor__17tU-"};